const POST_FILTER = `_type == "post" && !(_id in path("drafts.**")) && publishedAt <= now()`

export const AUTHOR_PROJECTION = `{
  name,
  slug,
  role,
  bio,
  twitter,
  linkedin,
  github,
  website,
  email,
  photo { asset, hotspot, "width": asset->metadata.dimensions.width, "height": asset->metadata.dimensions.height }
}`

export const COAUTHOR_PROJECTION = `{
  name,
  slug,
  role,
  photo { asset, hotspot, "width": asset->metadata.dimensions.width, "height": asset->metadata.dimensions.height }
}`

export const postCardFields = `
  _id,
  title,
  slug,
  publishedAt,
  excerpt,
  category,
  tags,
  "author": author-> ${AUTHOR_PROJECTION},
  "coAuthors": coAuthors[]-> ${COAUTHOR_PROJECTION},
  coverImage { asset, alt, hotspot, "width": asset->metadata.dimensions.width, "height": asset->metadata.dimensions.height }
`

export const postWithRelatedQuery = `
  *[${POST_FILTER} && slug.current == $slug][0] {
    ${postCardFields},
    body,
    _updatedAt,
    seo {
      metaTitle,
      metaDescription,
      ogImage { asset, alt, "width": asset->metadata.dimensions.width, "height": asset->metadata.dimensions.height }
    },
    "relatedPosts": relatedPosts[]->[${POST_FILTER}] {
      ${postCardFields}
    }[defined(_id)]
  }
`

export const autoRelatedQuery = `
  *[${POST_FILTER} && slug.current != $slug && count(tags[@ in $tags]) > 0]
    | order(publishedAt desc) [0...3] {
    ${postCardFields}
  }
`

export const categoryFallbackQuery = `
  *[${POST_FILTER} && slug.current != $slug && category == $category]
    | order(publishedAt desc) [0...3] {
    ${postCardFields}
  }
`
